import * as t from 'io-ts';
import { ImageDynamicType } from './image';

export const BookingImageDynamicType = t.intersection([
    ImageDynamicType,
    t.interface({
        imageType: t.union([
            t.literal('Exterior'),
            t.literal('Interior'),
            t.literal('Floorplan')
        ]),
    })
]);

export type BookingImage = t.TypeOf<typeof BookingImageDynamicType>;
